import React from "react";
import "./style.css";
import useContactSupport from "../../Hooks/useContactSupport";
import Footer from "../../component/footer";

const ContactSupport = () => {
  const { send, dataFields, setDataFields } = useContactSupport();

  return (
    <div className="main-CS absolute-bg contactsupport">
      <section className="contact-support-sec">
        <div className="bar-cs1">
          <div className="container-1440">
            <div className="row">
              <div className="col-lg-12">
                <span className="img-cs1">
                  <img src={require("../../Assets/img/chat-cs.png")} alt="" />
                </span>
                <h1>contact support</h1>
                <span className="img-cs2">
                  <img
                    src={require("../../Assets/img/handfree-cs.png")}
                    alt=""
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="form-sec">
        <div className="container-1440">
          <div className="row">
            <div className="col-lg-6 pt-3">
              <form
                type="submit"
                onSubmit={(e) => {
                  send(e);
                }}
              >
                <div className="csInput">
                  <input
                    required
                    type="text"
                    placeholder="Name"
                    onChange={(e) =>
                      setDataFields({ ...dataFields, name: e.target.value })
                    }
                    value={dataFields.name}
                  />
                </div>
                <div className="csInput">
                  <input
                    required
                    type="text"
                    placeholder="Company"
                    onChange={(e) =>
                      setDataFields({ ...dataFields, company: e.target.value })
                    }
                    value={dataFields.company}
                  />
                </div>
                <div className="csInput">
                  <input
                    required
                    type="text"
                    placeholder="Country"
                    onChange={(e) =>
                      setDataFields({ ...dataFields, country: e.target.value })
                    }
                    value={dataFields.country}
                  />
                </div>
                <div className="csInput">
                  <input
                    required
                    type="email"
                    placeholder="Email"
                    onChange={(e) =>
                      setDataFields({ ...dataFields, email: e.target.value })
                    }
                    value={dataFields.email}
                  />
                </div>
                <div className="csInput">
                  <input
                    required
                    type="number"
                    placeholder="Phone"
                    onChange={(e) =>
                      setDataFields({ ...dataFields, phone: e.target.value })
                    }
                    value={dataFields.phone}
                  />
                </div>
                <div className="csInput">
                  <textarea
                    required
                    id="story"
                    name="story"
                    placeholder="  Issue Description"
                    onChange={(e) =>
                      setDataFields({ ...dataFields, message: e.target.value })
                    }
                    value={dataFields.message}
                    rows="5"
                    cols="33"
                  ></textarea>
                </div>
                <div className=" btnCs">
                  <button type="submit">Send Message</button>
                </div>
              </form>
            </div>
            <div className="col-lg-6">
              <div className="imgRight">
                <img src={require("../../Assets/img/cs-girl.png")} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default ContactSupport;
